import { Events } from './events'
import { QuickStorage } from './quickStorage'

class ColorTheme {
  static init() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    ColorTheme.storeThemeToUse()
    ColorTheme.setBodyClass()
  }
  static getOptions() {
    return [
      {
        id: 'dark',
        name: 'Theme sombre',
      },
      {
        id: 'light',
        name: 'Theme claire',
      },
    ]
  }
  static changeTheme(theme) {
    QuickStorage.storeData('colorTheme', theme == 'light' ? 'light' : 'dark')
    // QuickStorage.storeData('colorTheme', 'dark')
    ColorTheme.storeThemeToUse()
    Events.dispatchEvent('color_theme_changed', ColorTheme.currentTheme())
    ColorTheme.setBodyClass()
  }
  static setBodyClass() {
    const currentTheme = ColorTheme.currentTheme()
    let themeToRemove
    if (currentTheme == 'dark') themeToRemove = 'light'
    else themeToRemove = 'dark'
    document.body.classList.add(currentTheme)
    document.body.classList.remove(themeToRemove)
  }
  static setDarkTheme() {
    ColorTheme.changeTheme(true)
  }
  static setLightTheme() {
    ColorTheme.changeTheme(false)
  }
  static currentTheme() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return 'dark'
    if (!window.colorTheme) ColorTheme.storeThemeToUse()
    return window.colorTheme
  }
  static storeThemeToUse() {
    const colorTheme = QuickStorage.getStored('colorTheme')
    window.colorTheme = colorTheme || 'dark'
  }

  static isDark() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return false
    const theme = ColorTheme.currentTheme()
    return theme == 'dark'
  }
  static isLight() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return true
    const theme = ColorTheme.currentTheme()
    return theme == 'light'
  }
}

export { ColorTheme }
